<template>
  <v-card>
    <v-img :src="require(`../assets/${job.imgPath}`)" class="black--text align-stretch">
      <v-row class="fill-height gray-overlay align-content-space-between py-5">
        <v-col cols="12">
          <div class="white--text text-center headline">
            {{ job.title }}
          </div>
          <template v-if="job.subtitle">
            <div class="white--text text-center body-1">
              {{ job.subtitle }}
            </div>
          </template>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-btn color="primary" large rounded @click="$router.push(`/career/job-offers/${job.jobId}`)">
            Érdekel
          </v-btn>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: 'jobCard2',
  components: {
    //
  },
  props: {
    job: Object,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
